import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=35b2853b&scoped=true&"
import script from "./editProfile.vue?vue&type=script&lang=js&"
export * from "./editProfile.vue?vue&type=script&lang=js&"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=35b2853b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2853b",
  null
  
)

export default component.exports